// TelcoTrack - Logger Service
// Centralized logging service

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private isEnabled(): boolean {
    return environment.logging.enableConsoleLogging;
  }

  private shouldLog(level: string): boolean {
    if (!this.isEnabled()) {
      return false;
    }

    const levels = ['debug', 'info', 'warn', 'error'];
    const currentLevel = environment.logging.level || 'debug';
    const currentIndex = levels.indexOf(currentLevel);
    const messageIndex = levels.indexOf(level);

    return messageIndex >= currentIndex;
  }

  debug(message: string, ...args: any[]): void {
    if (this.shouldLog('debug')) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  }

  info(message: string, ...args: any[]): void {
    if (this.shouldLog('info')) {
      console.info(`[INFO] ${message}`, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  }

  error(message: string, error?: any, ...args: any[]): void {
    if (this.shouldLog('error')) {
      if (error) {
        console.error(`[ERROR] ${message}`, error, ...args);
      } else {
        console.error(`[ERROR] ${message}`, ...args);
      }
    }
  }
}

